<template>
  <div>
    <!-- Debug: Mostrar estructura de feedCategories -->
    <b-card
      v-if="showDebug"
      class="mb-3"
      bg-variant="light"
    >
      <b-card-header>
        <strong>DEBUG - Estructura de feedCategories:</strong>
        <b-button
          size="sm"
          variant="outline-danger"
          class="ml-2"
          @click="copyToClipboard"
        >
          Copiar JSON
        </b-button>
      </b-card-header>
      <b-card-body>
        <pre class="mb-0" style="max-height: 300px; overflow: auto;">{{ debugInfo }}</pre>
      </b-card-body>
    </b-card>

    <b-form-group
      :label="label"
      :label-for="inputId"
      class="form-group-modern"
    >
    <multiselect
      :id="inputId"
      v-model="selectedCategory"
      :options="categoryOptions"
      :searchable="true"
      :allow-empty="false"
      :show-labels="false"
      placeholder="Buscar categoría..."
      label="description"
      track-by="id"
      class="modern-multiselect"
      @input="handleCategoryChange"
    >
        <template slot="noResult">
          <span>No se encontraron categorías</span>
        </template>
        <template slot="noOptions">
          <span>Cargando categorías...</span>
        </template>
      </multiselect>
    </b-form-group>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import Multiselect from 'vue-multiselect'

export default {
  name: 'CategorySelector',
  components: {
    Multiselect
  },
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    label: {
      type: String,
      default: 'ID de Categoría:'
    },
    inputId: {
      type: String,
      default: 'category-selector'
    }
  },
  setup (props, context) {
    const store = context.root.$store
    const selectedCategory = ref(null)
    const showDebug = ref(false) // Debug desactivado

    // Get category options from feedCategories
    const categoryOptions = computed(() => {
      const feedCategories = store.getters.feedCategories
      if (!feedCategories || !Array.isArray(feedCategories)) {
        return []
      }

      // feedCategories should be an array of category objects with id and name
      return feedCategories
    })

    // Debug info
    const debugInfo = computed(() => {
      const feedCategories = store.getters.feedCategories
      return JSON.stringify({
        feedCategories: feedCategories,
        isArray: Array.isArray(feedCategories),
        length: feedCategories ? feedCategories.length : 0,
        firstItem: feedCategories && feedCategories.length > 0 ? feedCategories[0] : null,
        categoryOptions: categoryOptions.value,
        categoryOptionsLength: categoryOptions.value.length
      }, null, 2)
    })

    const copyToClipboard = () => {
      const textArea = document.createElement('textarea')
      textArea.value = debugInfo.value
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      context.root.$bvToast.toast('JSON copiado al portapapeles', {
        title: 'Copiado',
        variant: 'success',
        autoHideDelay: 2000
      })
    }

    // Watch for value changes from parent
    watch(() => props.value, (newValue) => {
      if (newValue && categoryOptions.value.length > 0) {
        const foundCategory = categoryOptions.value.find(option => option.id === Number(newValue))
        if (foundCategory) {
          selectedCategory.value = foundCategory
        }
      } else {
        selectedCategory.value = null
      }
    }, { immediate: true })

    // Also watch categoryOptions to update when they load
    watch(categoryOptions, (newOptions) => {
      if (props.value && newOptions.length > 0) {
        const foundCategory = newOptions.find(option => option.id === Number(props.value))
        if (foundCategory) {
          selectedCategory.value = foundCategory
        }
      }
    })

    // Handle category selection change
    const handleCategoryChange = (selected) => {
      if (selected) {
        context.emit('input', selected.id)
      } else {
        context.emit('input', null)
      }
    }

    return {
      selectedCategory,
      categoryOptions,
      handleCategoryChange,
      showDebug,
      debugInfo,
      copyToClipboard
    }
  }
}
</script>

<style scoped>
.form-group-modern {
  margin-bottom: 1.5rem;
}

.modern-multiselect >>> .multiselect__tags {
  border-radius: 8px;
  border-color: #ced4da;
  min-height: 38px;
  padding: 8px 40px 0 8px;
}

.modern-multiselect >>> .multiselect__input,
.modern-multiselect >>> .multiselect__single {
  font-size: 1rem;
  line-height: 1.5;
  padding: 0;
  margin-bottom: 0;
}

.modern-multiselect >>> .multiselect__placeholder {
  color: #6c757d;
  padding-top: 0;
  margin-bottom: 0;
}

.modern-multiselect >>> .multiselect__option {
  padding: 10px 12px;
}

.modern-multiselect >>> .multiselect__option--highlight {
  background: #007bff;
  color: white;
}

.modern-multiselect >>> .multiselect__option--selected {
  background: #e9ecef;
  color: #333;
  font-weight: 500;
}

.modern-multiselect >>> .multiselect__option--selected.multiselect__option--highlight {
  background: #007bff;
  color: white;
}
</style>




// WEBPACK FOOTER //
// src/expertoRetail/views/trade/components/CategorySelector.vue